var variation = [];

$(function() {

	// カート合計金額
	cartCalculation(false);

	if ($('.cart_main_list .cart_line').length === 0) {
		$('.cart_payment button').removeClass('btn_01');
		$('.cart_payment button').addClass('btn_disable');
	}

	// チェックアウト
	$('body').on('click', '#cart .checkout', function() {

		if ($('body').attr('invalid-customer') === 'true') {
			location.href = $('header').attr('shop-url') + '/pages/invalid-customer';
		} else {
			$('#checkout_form').submit();
		}

		return false;
	});
});
